import { NavigationTracker } from "./NavigationTracker";

if (typeof window !== "undefined") {
  (window as any).FScript = new NavigationTracker((event) => {
    if (event.type === "page_load") {
      console.log(`Metrics: Page enter (${event.detail})`, event.url);
    } else if (event.type === "page_reload") {
      console.log("Metrics: Page reloaded", event.url);
    } else if (event.type === "browser_back") {
      console.log("Metrics: Browser back button", event.url);
    } else if (event.type === "browser_forward") {
      console.log("Metrics: Browser forward button", event.url);
    }
  });
}
